import { HomeService } from 'features/projects/service'

export const homeQueries = {
  projectSearch: (
    service: HomeService,
    searchType: string,
    searchTerm: string,
  ) => ({
    queryKey: ['home', 'projects', searchType, searchTerm] as const,
    queryFn: () => service.fetchProjectsBySearch(searchType, searchTerm),
    refetchOnWindowFocus: false,
  }),

  groupProjects: (service: HomeService) => ({
    queryKey: ['home', 'group-projects'] as const,
    queryFn: () => service.fetchGroupProjectsBySearch(),
    refetchOnWindowFocus: false,
  }),

  projectMeta: (service: HomeService) => ({
    queryKey: ['home', 'meta'] as const,
    queryFn: () => service.getProjectMeta(),
  }),
}
